import dayjs, { Dayjs } from "dayjs";

interface DeliveryTimelineCutoffOptions {
  deliveryDate?: string | null;
  orderGap?: number | null;
  shiftHour?: string | null;
  isNextDay?: boolean;
}

interface ShouldDisplayDeliveryTimelineOptions
  extends DeliveryTimelineCutoffOptions {
  now?: Dayjs;
}

const parseShiftHour = (shiftHour: string) => {
  const [hours, minutes = 0, seconds = 0] = shiftHour
    .split(":")
    .map(Number);

  if (
    [hours, minutes, seconds].some(
      (value) => Number.isNaN(value) || value < 0,
    )
  ) {
    return null;
  }

  return { hours, minutes, seconds };
};

export const getDeliveryTimelineCutoff = ({
  deliveryDate,
  orderGap,
  shiftHour,
  isNextDay = false,
}: DeliveryTimelineCutoffOptions): Dayjs | null => {
  if (!deliveryDate || orderGap === null || orderGap === undefined || !shiftHour) {
    return null;
  }

  const parsedShiftHour = parseShiftHour(shiftHour);

  if (!parsedShiftHour) {
    return null;
  }

  const deliveryDay = dayjs(deliveryDate);

  if (!deliveryDay.isValid()) {
    return null;
  }

  const daysToSubtract = orderGap + (isNextDay ? 1 : 0);

  return deliveryDay
    .subtract(daysToSubtract, "day")
    .hour(parsedShiftHour.hours)
    .minute(parsedShiftHour.minutes)
    .second(parsedShiftHour.seconds)
    .millisecond(0);
};

export const shouldDisplayDeliveryTimeline = ({
  now = dayjs(),
  ...options
}: ShouldDisplayDeliveryTimelineOptions): boolean => {
  const cutoff = getDeliveryTimelineCutoff(options);

  if (!cutoff) {
    return false;
  }

  return now.isAfter(cutoff);
};